import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {TaskService} from '../services/task.service';
import {NzMessageService} from 'ng-zorro-antd/message';

@Component({
  selector: 'nf-archived-board',
  templateUrl: './archived-board.component.html',
  styleUrls: ['./archived-board.component.css']
})
export class ArchivedBoardComponent implements OnInit {

  queryParam = {
    page: 1,
    size: 10,
    recycleBinMode: 'archived_board',
    boardId: '',
    search: ''
  };
  total = 0;
  totalPages = 1;
  archivedBoardList = [];
  contentHeight;
  @Output() refreshBoardList: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private taskService: TaskService,
    private message: NzMessageService
  ) { }

  ngOnInit(): void {
    this.contentHeight = window.innerHeight - 180 + 'px';
    this.pageChange();
  }

  searchByParam() {
    this.queryParam.page = 1;
    this.pageChange();
  }

  pageChange() {
    this.taskService.getRecycleData(this.queryParam).subscribe(res => {
      this.handleQueryResult(res);
    })
  }

  handleQueryResult(res) {
    if (res) {
      this.archivedBoardList = res.data || [];
      if (res.page) {
        this.total = res.page.totalElements;
        this.totalPages = res.page.totalPages;
      } else {
        this.total = 0;
      }
    }
  }

  restoreBoard(archivedBoard, i) {
    this.taskService.restoreRecycle(archivedBoard.id).subscribe(res => {
      if (res) {
        const index = this.queryParam.page * this.queryParam.size + i + 1;
        if (index === this.total) {
          this.queryParam.page = this.queryParam.page - 1;
        }
        this.message.success('面板恢复成功！');
        this.refreshBoardList.emit();
        this.pageChange();
      } else {
        this.message.error('面板恢复失败！');
      }
    });
  }
}
